import Footer from "../components/FooterComponents/Footer";
import SEO from "../components/SEO";
import { seoConfig } from "../data/seoConfig";

const Services = () => {
  const services = [
    {
      icon: "/assets/images/services/s1.png",
      title: "Frontend Development",
      description:
        "A perfect balance of user experience, performance efficiency, and scalable architecture.",
    },
    {
      icon: "/assets/images/services/s2.png",
      title: "Backend Development",
      description:
        "Robust, scalable architecture with strong security and optimized performance.",
    },
    {
      icon: "/assets/images/services/s3.png",
      title: "Mobile App Development",
      description:
        "Seamless cross-platform support with user-centric and high-performance delivery.",
    },
    {
      icon: "/assets/images/services/s4.png",
      title: "Web Design",
      description:
        "Responsive, mobile-first design with intuitive UI and accessibility.",
    },
    {
      icon: "/assets/images/services/s5.png",
      title: "Custom Software Development",
      description:
        "Tailored software solutions aligned with business goals and scalability.",
    },
    {
      icon: "/assets/images/services/s1.png",
      title: "Internship Programs",
      description:
        "Professional software development internship for aspiring developers with hands-on project experience.",
    }
   
  ];

  return (
    <>
    <SEO {...seoConfig.services} />
    <div className="py-5 bg-light" id="services">
        
      <div className="container">
        <h1 className="text-center fw-bold mb-5">
          Our Services
        </h1>
        

        <div className="row g-4">
          {services.map((item, index) => (
            <div key={index} className="col-lg-4 col-md-6 col-12">
              <div className="card h-100 text-center p-4 shadow-sm service-card home-div">
                <div className="service-icon-wrap mx-auto mb-3">
                  <img
                    src={item.icon}
                    alt={item.title}
                    width="80"
                    height="80"
                    className="service-icon"
                    loading="lazy"
                  />
                </div>

                <h5 className="fw-bolder pt-3">{item.title}</h5>
                <p className="text-muted pt-3">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      
    </div>

    <div className="container mt-5 pt-5">
      <div className="row align-items-center">
        <div className="col-12 col-md-6 col-lg-6">
          <h1 className="fw-bolder mb-4">Project Training & Support</h1>
          <p className="fw-bold mb-4">
            We provide comprehensive training programs to ensure your team is fully equipped to manage, maintain, and scale your software solutions effectively.
          </p>
          <ul className="mt-4 ms-3">
            <li className="mt-3">Team Training & Onboarding</li>
            <li className="mt-2">Technical Documentation</li>
            <li className="mt-2">Best Practices Workshops</li>
            <li className="mt-2">Ongoing Support & Maintenance</li>
            <li className="mt-2">Performance Optimization Guidance</li>
          </ul>
        </div>
        <div className="col-12 col-md-6 col-lg-6">
          <img 
            src="/assets/images/hero/about.jpeg" 
            className="img-fluid w-100 rounded page-section-image"
            alt="Project Training"
            loading="lazy"
          />
        </div>
      </div>
    </div>
    
    <Footer />
    </>
  );
};

export default Services;
